import React, { useState, useEffect, useRef } from 'react'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Text from '../../../components/Text';
import usePrevious from "../../../utils/usePrevious";
import { parentalCheckPin, resetParental } from '../actions';

import styles from "./index.module.css";

const pinFocusList = [true, false, false, false];
const parentalFocusList = [true, false];
let inputList;

function PinOverlay(props) {
  const { checkLoaded, pinCheck, tvMode } = props;

  const [valueList, setValueList] = useState({
    0: '',
    1: '',
    2: '',
    3: ''
  });
  const [focusList, _setFocusList] = useState(pinFocusList);
  const focusListRef = useRef(focusList);
  const setFocusList = (data) => {
    focusListRef.current = data;
    _setFocusList(data);
  }
  const [pageFocus, _setPageFocus] = useState(parentalFocusList);
  const pageFocusRef = useRef(pageFocus);
  const setPageFocus = (data) => {
    pageFocusRef.current = data;
    _setPageFocus(data);
  }
  const [error, setError] = useState(null);
  const [deleteValue, setDeleteValue] = useState(false);

  const prevCheckLoaded = usePrevious(checkLoaded);

  useEffect(() => {
    props.resetParental();

    if (tvMode) {
      document.addEventListener('keydown', changeFocus);
    }

    inputList = document.getElementById('parental-0').getElementsByTagName('input');

    return () => {
      if (tvMode) {
        document.removeEventListener("keydown", changeFocus);
      }
    };
    /* eslint-disable */
  }, []);

  useEffect(() => {
    if (prevCheckLoaded !== checkLoaded && prevCheckLoaded !== undefined && checkLoaded) {
      if (pinCheck) {
        props.onSubmit();
      } else {
        showError('Invalid PIN');
      }
    }
    /* eslint-disable */
  }, [checkLoaded]);

  const onChange = (e, index) => {
    const { value } = e.target;

    let newInputValueList = Object.assign({}, valueList);
    let newFocusList = focusList.map(value => value);

    if (!isNaN(value)) {
      if (newInputValueList[index]) {
        if (newInputValueList[index] !== value.charAt(0)) {
          newInputValueList[index] = value.charAt(0);
        } else if (newInputValueList[index] !== value.charAt(value.length - 1)) {
          newInputValueList[index] = value.charAt(value.length - 1);
        }
      } else {
        newInputValueList[index] = value.charAt(0);
      }

      if (index < (newFocusList.length - 1)) {
        if (!newInputValueList[index + 1] && newInputValueList[index]) {
          newFocusList[index + 1] = true;
          newFocusList[index] = false;
        } else {
          inputList[newFocusList.indexOf(true)].blur();
        }
      } else {
        if (tvMode) {
          inputList[newFocusList.indexOf(true)].blur();
          setPageFocus([false, true]);
          document.getElementById('parental-1').focus();
        }
      }
    }

    if (deleteValue) {
      newFocusList[index] = true;
      newFocusList[index + 1] = false;

      setDeleteValue(false);
    }

    if (focusList.indexOf(true) !== newFocusList.indexOf(true)) {
      setFocusList(newFocusList);
      inputList[newFocusList.indexOf(true)].focus();
      inputList[focusList.indexOf(true)].blur();
    }

    setValueList(newInputValueList);
    setError(null);
  }

  const trackKeyDown = (e, index) => {
    if (e.keyCode === 8) {
      if (!e.target.value) {
        inputList[index - 1].focus();

        setDeleteValue(true);
      }
    }
  }

  const trackKeyUp = (e) => {
    if (e.keyCode === 13) {
      onSubmitClick();
    }
  }

  const showError = (text) => {
    setFocusList(pinFocusList);
    setPageFocus(parentalFocusList);
    setValueList({
      0: '',
      1: '',
      2: '',
      3: '',
    });

    setError(text);
  }

  const onSubmitClick = () => {
    const pinCode = valueList[0] + valueList[1] + valueList[2] + valueList[3];

    if (pinCode.length === 4) {
      props.parentalCheckPin(pinCode);
    } else {
      showError('Invalid PIN');
    }
  }

  const changeFocus = (e) => {
    const focusListUpdate = focusListRef.current;
    const pageFocusUpdate = pageFocusRef.current;
    let newFocusList = pageFocusUpdate.map(value => value);
    let newFocusInputList = focusListUpdate.map(value => value);
    let selectedIndex = newFocusList.indexOf(true);
    let selectedInputIndex = newFocusInputList.indexOf(true);
    let focusChange = false;
    let focusInputChange = false;

    if (e.keyCode === 37) { // LEFT KEY
      if (selectedIndex === 0) {
        if (selectedInputIndex > 0) {
          newFocusInputList[selectedInputIndex - 1] = true;
          newFocusInputList[selectedInputIndex] = false;

          focusInputChange = true;
          selectedInputIndex = selectedInputIndex - 1;
        }
      } else {
        newFocusList[selectedIndex - 1] = true;
        newFocusList[selectedIndex] = false;

        focusChange = true;
        selectedIndex = selectedIndex - 1;
      }
    } else if (e.keyCode === 39) { // RIGHT KEY
      if (selectedIndex === 0) {
        if (selectedInputIndex < (newFocusInputList.length - 1)) {
          newFocusInputList[selectedInputIndex + 1] = true;
          newFocusInputList[selectedInputIndex] = false;

          focusInputChange = true;
          selectedInputIndex = selectedInputIndex + 1;
        } else {
          newFocusList[selectedIndex + 1] = true;
          newFocusList[selectedIndex] = false;

          focusChange = true;
          selectedIndex = selectedIndex + 1;
        }
      } else {
        if (selectedIndex < (newFocusList.length - 1)) {
          newFocusList[selectedIndex + 1] = true;
          newFocusList[selectedIndex] = false;

          focusChange = true;
          selectedIndex = selectedIndex + 1;
        }
      }
    } else if (e.keyCode === 10009 || e.keyCode === 461) { // BACK KEY TIZEN & LG
      props.onBack();
    }

    if (focusChange) {
      document.getElementById(`parental-${selectedIndex}`).focus();
      document.getElementById(`parental-${pageFocusUpdate.indexOf(true)}`).blur();
      setPageFocus(newFocusList);
    }

    if (focusInputChange) {
      inputList[focusListUpdate.indexOf(true)].blur();
      setFocusList(newFocusInputList);
    }
  };

  return (
    <div className={styles['wrapper']}>
      <Text className={`${styles['title']} ${ error ? styles['highlight-red'] : "" }`} type="h4">
        {
          error ?
            error
            :
            'Enter PIN to watch restricted content'
        }
      </Text>

      <div className={styles['container']}>
        <Input
          type="pin"
          onChange={onChange}
          value={valueList}
          focusList={focusList}
          id="parental-0"
          focus={pageFocus[0] ? true : false}
          error={error}
          onKeyUp={trackKeyUp}
          onKeyDown={trackKeyDown}
        />

        <Button
          id="parental-1"
          onClick={onSubmitClick}
          text="Submit"
          style={{ minWidth: '240px' }}
          className={styles['submit-button']}
        />
      </div>

      <Text type="l32" className={styles['description']}>
        Forgot PIN? Reset it under More > Parental Control
      </Text>
    </div>
  );
}

const mapStateToProps = (state) => ({
  checkLoaded: state.parental.checkLoaded,
  pinCheck: state.parental.pinCheck,
  tvMode: state.app.tvMode
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      parentalCheckPin,
      resetParental
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PinOverlay);
